/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1DeviceMainDetails } from '../models/V1DeviceMainDetails';
import { V1DeviceResults } from '../models/V1DeviceResults';
import { V1Metrics } from '../models/V1Metrics';
import { HttpFile } from '../http/http';

export class V1DeviceStatsResponse {
    'results'?: Array<V1DeviceResults>;
    'totals'?: V1Metrics;
    'details'?: V1DeviceMainDetails;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<V1DeviceResults>",
            "format": ""
        },
        {
            "name": "totals",
            "baseName": "totals",
            "type": "V1Metrics",
            "format": ""
        },
        {
            "name": "details",
            "baseName": "details",
            "type": "V1DeviceMainDetails",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1DeviceStatsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

